<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Dynamic AX', to: '/ax/items/register-item-ax' },
      { label: 'Edit' }
    ]" title="Edit Dynamic AX" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4">
      <div class="w-1/2">
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Product Name
          </label>
          <input id="ProductName"  disabled ="text" :value="itemDynamic?.ProductName" placeholder=""
            class="w-full rounded-md px-4 border bg-gray-300 text-gray-400 py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>
        <div class="mb-3">
          <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
            Name of Printing
          </label>
          <input id="ProductName"  disabled ="text" :value="itemDynamic?.NameOfPrinting" placeholder=""
            class="w-full rounded-md px-4 border bg-gray-300 text-gray-400 py-2.5 text-sm focus:outline-none focus:ring-2" />
        </div>

        <div class="mb-3 px-3" v-for="(value, key) in itemDynamic" :key="key">
              <div class="form-group row" v-if="allowedEdit.includes(key)">
                <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                  {{ formatKey(key) }}
                  </label>
                  <input
                    type="text"
                     class="w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2"
                    placeholder=""
                    :disabled="isLoading"
                    :class="isLoading ? 'bg-gray-300 text-gray-400' : ''"
                    :value="value"
                    @change="updateValue($event, key)"
                  />
                
              </div>
            </div>
        <div class=" mt-4 mb-3 mr-0 flex justify-start">
          <!-- <button @click="editItemAx()" class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button> -->
          <button
  @click="editItemAx"
  :disabled="isLoading"
  class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3 flex items-center justify-center gap-2"
>
  <span v-if="isLoading" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
  <span>{{ isLoading ? 'Saving...' : 'Save' }}</span>
</button>



          <button type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
            <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm"
              :to="{ path: '/ax/items/register-item-ax' }">
              Cancel
            </router-link>
          </button>
        </div>
      </div>
    </div>
    <!-- <b-overlay :show="isLoading" rounded="sm">
    <div class="card mt-2">
      <div class="card-header text-center bg-primary">
        <h3>Update Detail Body Item Dynamic</h3>
      </div>
      <div class="card-body">
        <b-row v-if="successMessage" class="justify-content-center mt-2">
          <b-col lg="10">
            <b-alert variant="success" 
              dismissible
              :show="dismissCountDown"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged">
              {{  successMessage }}
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-if="errorMessage" class="justify-content-center mt-2">
          <b-col lg="10">
            <b-alert variant="danger" 
              dismissible
              :show="dismissCountDown"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged">
              {{  errorMessage }}
            </b-alert>
          </b-col>
        </b-row>
        <h5>
          <router-link
            :to="{
              name: registerItemAx.name,
            }"
          >
            <span class="badge badge-primary"
              ><i class="fa fa-angle-left mr-1"></i>Back</span
            >
          </router-link>
        </h5>
        <div class="row">
          <div class="form-group col-md-12">
            <div class="form-group row">
              <label class="label-key col-sm-2"> Product Name </label>
              <div class="col-sm-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  :value="itemDynamic?.ProductName"
                  disabled
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="label-key col-sm-2"> Name Of Printing </label>
              <div class="col-sm-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  :value="itemDynamic?.NameOfPrinting"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="form-group col-md-12">
            <div v-for="(value, key) in itemDynamic" :key="key">
              <div class="form-group row" v-if="allowedEdit.includes(key)">
                <label class="label-key col-sm-2">{{ key }} :</label>
                <div class="col-sm-6">
                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    :value="value"
                    @change="updateValue($event, key)"
                  />
                </div>
              </div>
            </div>

            <div class="form-group row justify-content-center">
              <div class="col-sm-4">
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                  @click="editItemAx()"
                  :disabled="isDisable"
                >
                  <i class="fa fa-save"></i>
                  Update
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-3"></div>
        </div>
      </div>
    </div>
  </b-overlay> -->
  </div>
  
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { registerItemAx } from '../../router/microsoft365';
import {EventBus} from '../../event-bus'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'

export default {
  name: 'UpdateRegisterAX',
  components: {
    HeaderBreadcrumbs
  },
  data() {
    return {
      registerItemAx,
      itemDynamic: {},
      allowedEdit:[
      "PisNumber",
      "ItemGrouping",
      "ProductOwner",
      "Tax",
      "Tag"
      ],
      dismissSecs: 5,
      dismissCountDown: 5,
    };
  },
  watch: {
    successMessage: function() {
      if (!this.successMessage) return;
      this.countDownChanged(5)
      EventBus.$emit('show-toast', {
            message:'New dynamic ax has been updated.',
            type: 'success',
          });
      setTimeout(() => {
        this.$router.push('/ax/items/register-item-ax');
      }, 5000);
    },
    errorMessage: function() {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'success',
          });
      this.countDownChanged(5)
    },
    isError: function() {
      if (!this.isError) return;
      EventBus.$emit('show-toast', {
            message:'Ops. Something went wrong !',
            type: 'error',
          });
   //   this.alertMsg('Ops. Something went wrong !', 'error');
    },

    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Update Item AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  created: function() {
    const id = this.$route.params.id;
    this.fetchItemAxById({ id }).then((result) =>
      typeof result?.details === 'object'
        ? (this.itemDynamic = result?.details)
        : (this.itemDynamic = null),
    );
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.registerAx.isLoading,
      isError: (state) => state.registerAx.isError,
      successMessage: (state) => state.registerAx.SuccessMessage,
      errorMessage: (state) => state.registerAx.ErrorMessage,
      item: (state) => state.registerAx.item,
    }),
    isDisable() {
      return !this.itemDynamic;
    },
  },
  methods: {
    ...mapActions('registerAx', ['fetchItemAxById', 'updateDetailItemDynamic']),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    editItemAx() {
      const payload = {
        id: this.$route.params.id,
        details: this.itemDynamic,
      };
      this.updateDetailItemDynamic(payload);
    },
    formatKey(key) {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2');
    },
    updateValue(e, key) {
      const dataItem = this.itemDynamic;
      dataItem[key] = e?.target.value;
    },

    alertMsg(msg, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: msg,
        timer: 10000,
        text: this.message,
      });
    },
  },
};
</script>
